import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_vm._v(" "+_vm._s(_vm.customerCount)+" customers have "+_vm._s(_vm.shipmentCount)+" shipments. "),_c('ul',_vm._l((_vm.shipmentSizes),function(s,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(i)+" meal - "+_vm._s(s)+" shipments ("+_vm._s(((s / _vm.shipmentCount) * 100).toLocaleString())+"%) ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }